export enum EMatomoActionCustomDimension {
  Checkout = 2
}

export const MatomoSiteId = {
  production: '16525',
  test: '420'
};
